import UploadProgressModal from "./UploadProgressModal";

export default UploadProgressModal;
